import { API } from 'helpers/api/endpoints';
import useData from 'hooks/useData';
import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { backendProductTypes, ALLOWED_PRODUCTS } from './SingelFileUpload';

type Props = {
  setProductType: Dispatch<SetStateAction<backendProductTypes>>;
};

const productLabels: Record<backendProductTypes, string> = {
  FSM: 'FSM',
  FlowsterStudio: 'Flowster Studio',
  PasswordResetPortal: 'Password Reset Portal',
  FlowsterAIStudio: 'Flowster AI Studio',
};
export default function ProductDropdown({ setProductType }: Readonly<Props>) {
  const { t } = useTranslation('licenses');
  const { data, loading } = useData<backendProductTypes[]>(
    API.licence.softwareTypes
  );

  const options = useMemo(
    () =>
      data
        ?.filter((product) => ALLOWED_PRODUCTS.includes(product))
        .map((product) => ({
          label: productLabels[product] ?? product,
          value: product,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [data]
  );

  // Keep the parent in sync with the displayed default once the server list arrives
  useEffect(() => {
    if (options?.length) setProductType(options[0].value);
  }, [options, setProductType]);

  if (loading) return <Spinner />;

  return (
    <>
      <Form.Label className="mb-1 mt-2 fs--1">{t('product')}</Form.Label>
      {options && (
        <Select
          classNamePrefix="react-select"
          defaultValue={options[0]}
          options={options}
          onChange={(e) => {
            if (!e) return;
            setProductType(e.value);
          }}
        />
      )}
    </>
  );
}
